export default __webpack_public_path__ + "static/media/seq_time_prediction.9efce333.png";